import React from 'react';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';

export const getOnClickClearAllHandler = setSelectedFilters => (e) => {
  e.preventDefault();
  // Calling with no params will clear the filter
  setSelectedFilters();
};

const ClearAllLink = ({
  setSelectedFilters,
  clearAllText = '',
}) => (
  <Link
    link="?filters=[]"
    extraClass="filter__clear-all"
    onClick={getOnClickClearAllHandler(setSelectedFilters)}
  >
    {clearAllText}
  </Link>
);

ClearAllLink.propTypes = {
  setSelectedFilters: PropTypes.func.isRequired,
  clearAllText: PropTypes.string.isRequired,
};

export default ClearAllLink;
